<template>
  <div class="content has_breadcrumb">
    <base-breadcrumb
      style="position: fixed; background-color: #fff"
      :data="[
        {
          routeName: 'students',
          name: 'Students'
        },
        {
          routeName: 'studentCommbook',
          name: 'Commbook'
        },
        {
          name: `${firstName} ${lastName}`
        }
      ]"
      slot="breadcrumb"
    />
    <GgPage pageType="1" title="Commbook" class="commbook" v-if="commbookData">
      <div class="commbook-top">
        <div class="commbook-title">{{ commbookData.title }}</div>
        <div class="commbook-topic">{{ commbookData.topic }}</div>
      </div>
      <div class="commbook-msg" v-loading="loading">
        <div class="commbook-msg-item">
          <div class="msg-header">
            <head-img
              class="user-box"
              :src="commbookData.photo"
              :firstName="commbookData.pubUserFirstname"
              :lastName="commbookData.pubUserLastname"
              line-height="32"
            ></head-img>
            <span class="user-name">{{ commbookData.pubUsername }}</span>
            <span class="msg-time">{{ formatTime(commbookData.createTime) }}</span>
          </div>
          <div class="msg-content">
            <p v-html="$escape2Html(commbookData.message)"></p>
            <div
              v-for="(imgItem, key) in commbookData.fileList || []"
              :key="key"
              style="padding-top: 10px"
            >
              <div
                :class="`pdf-box `"
                v-if="/\.pdf$/.test(imgItem.src)"
                :title="imgItem.fileName"
                @click="onOpenPdfFile(imgItem.src, imgItem.fileName)"
              >
                <canvas :class="`Bthe-canvas'${Math.random()}`"></canvas>
                <p class="pdf-intro">
                  <img
                    :src="require('@/assets/images/icons/attached_pdf.png')"
                    style="width: 20px"
                    alt
                  />
                  {{ imgItem.fileName }}
                </p>
              </div>
              <img
                v-else
                style="display: block; width: 240px"
                :src="imgItem.src"
                @click="priviewImg(imgItem.src)"
              />
            </div>
          </div>
        </div>
        <div class="commbook-msg-item" v-for="msg in responseList" :key="msg.id">
          <div class="msg-header">
            <head-img
              class="user-box"
              :src="msg.photo"
              :firstName="msg.responseUserFirstname"
              :lastName="msg.responseUserLastname"
              line-height="32"
            ></head-img>
            <span class="user-name">{{ msg.responseUsername }}</span>
            <span class="msg-time">{{ formatTime(msg.modifyTime) }}</span>
          </div>
          <div class="msg-content">
            <p v-html="$escape2Html(msg.response)"></p>
            <div v-for="(imgItem, key) in msg.fileList" :key="key" style="padding-top: 10px">
              <div
                :class="`pdf-box `"
                v-if="/\.pdf$/.test(imgItem.src)"
                :title="imgItem.fileName"
                @click="onOpenPdfFile(imgItem.src, imgItem.fileName)"
              >
                <canvas :class="`Bthe-canvas'${Math.random()}`"></canvas>
                <p class="pdf-intro">
                  <img
                    :src="require('@/assets/images/icons/attached_pdf.png')"
                    style="width: 20px"
                    alt
                  />
                  {{ imgItem.fileName }}
                </p>
              </div>
              <img
                v-else
                style="display: block; width: 240px"
                :src="imgItem"
                @click="priviewImg(imgItem.src)"
              />
            </div>
          </div>
        </div>
      </div>
    </GgPage>
    <gg-view-img v-if="isViewImg" :visible.sync="isViewImg" :src="viewImg" name="Preview" />
  </div>
</template>

<script>
import moment from 'moment'
const PDFJS = require('pdfjs-dist')
PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry')
export default {
  name: 'commbookPreview',
  data() {
    return {
      loading: false,
      pdfPages: [],
      pdfnum: 0,
      isViewImg: false,
      viewImg: '',
      commbookData: null,
      responseList: [],
      firstName: this.$route.query.firstName || '',
      lastName: this.$route.query.lastName || '',
      is_loading: false
    }
  },
  created() {
    this.commbookData = JSON.parse(sessionStorage.getItem('commbookPreview'))
    if (this.commbookData.fileObject) {
      this.commbookData.fileList = JSON.parse(this.commbookData.fileObject)
    }
    console.log('commbookData', this.commbookData.fileList)
    this.responseList = (this.commbookData.responseDTOList || []).map((item) => {
      if (item.fileObject) {
        item.fileList = JSON.parse(item.fileObject)
      }
      return item
    })

    this.pdfPages = []
    this.getPdfData()
  },
  methods: {
    formatTime(time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').local().format('DD/MM/YYYY H:mm A')
    },
    onOpenPdfFile(url, name) {
      let needPrint = 1
      // window.open(
      //   `${url}`
      // );
      // console.log(process)
      let newUrl = this.$router.resolve({
        path: `/testFileView?url=${url}&name=${name}&${needPrint}`
      })
      window.open(newUrl.href, '_blank')
    },
    priviewImg(e) {
      this.isViewImg = true
      this.viewImg = e
      // window.open(`../testFileView?imgUrl=${e}&name=preview&needBack=1`,'_self');
    },
    getPdfData() {
      if (this.commbookData.fileList) {
        this.commbookData.fileList.forEach((img) => {
          if (/\.pdf$/.test(img)) {
            this.pdfPages.push(img)
          }
        })
      }
      if (this.commbookData.responseDTOList) {
        this.commbookData.responseDTOList.forEach((resItem) => {
          if (resItem.fileList) {
            resItem.fileList.forEach((img_r) => {
              if (/\.pdf$/.test(img_r)) {
                this.pdfPages.push(img_r)
              }
            })
          }
        })
      }
      if (this.pdfPages.length > 0) {
        this.loading = true
        setTimeout(() => {
          this.pdfnum = 0
          this._loadFile()
        }, 500)
      }
    },
    _loadFile() {
      if (this.is_loading) {
        return false
      }
      let url = this.pdfPages[this.pdfnum]
      PDFJS.getDocument(url)
        .promise.then((pdf) => {
          this.pdfDoc = pdf
          this.pages = this.pdfDoc.numPages
          // console.log('document函数')
          this.$nextTick(() => {
            this._renderPage()
            this.is_loading = true
          })
        })
        .catch(() => {
          this.pdfnum += 1
          this._loadFile()
          this.loading = false
        })
    },
    _renderPage() {
      this.pdfDoc.getPage(1).then((page) => {
        let canvas = document.getElementsByTagName(`canvas`)[this.pdfnum]

        var vp = page.getViewport({ scale: 1 })
        let ctx = canvas.getContext('2d')
        let dpr = window.devicePixelRatio || 1
        let bsr =
          ctx.webkitBackingStorePixelRatio ||
          ctx.mozBackingStorePixelRatio ||
          ctx.msBackingStorePixelRatio ||
          ctx.oBackingStorePixelRatio ||
          ctx.backingStorePixelRatio ||
          1
        let ratio = dpr / bsr
        let viewport = page.getViewport({
          scale: window.innerWidth / vp.width
        })
        canvas.width = viewport.width * ratio
        canvas.height = viewport.height * ratio
        canvas.style.width = 240 + 'px'
        canvas.style.height = 240 + 'px'
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport
        }
        page.render(renderContext)
        this.is_loading = false
        this.loading = false

        this.pdfnum += 1
        if (this.pdfnum < this.pdfPages.length) {
          this._loadFile()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.commbook-top {
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;

  .commbook-title {
    font-family: OpenSans-Bold;
    font-size: 22px;
    font-weight: bold;
    color: #202124;
    line-height: 30px;
  }

  .commbook-topic {
    margin-top: 8px;
    height: 20px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    background: #e9f3ff;
    border-radius: 10px;
    color: #1a73e8;
    font-size: 12px;
    font-family: Roboto;
    width: fit-content;
  }
}

.commbook-msg {
  padding: 20px;

  .commbook-msg-item {
    margin-bottom: 20px;

    .msg-header {
      display: flex;
      align-items: center;
      font-family: Roboto;

      .user-box {
        margin-right: 10px;
      }

      .user-name {
        font-size: 14px;
        color: #202124;
        margin-right: 10px;
      }

      .msg-time {
        font-size: 12px;
        color: #b4b4b4;
      }
    }

    .msg-content {
      margin-top: 10px;
      padding-left: 42px;
      font-family: Roboto;
      font-size: 14px;
      color: #202124;

      p {
        margin-bottom: 10px;
      }

      img,
      .pdf-box {
        cursor: pointer;
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>
